import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { authenticatorSettings } from './login/authenticatorSettings';
import { useGet } from '../hooks/useApi';
import { systemApi } from '../APIs/systemApi';
import { cognitoConstants } from '../consts';

export const Login = () => {
    const { route, user } = useAuthenticator((context) => [context.route]);
    const { data: systemInfo } = useGet(systemApi.get.info);

    // 初回ログイン時の電話番号入力画面で、電話番号の先頭に「0」がついていたら除く処理
    useEffect(() => {
        // Authenticatorの画面描画・遷移に合わせて input 要素を監視
        const handleInput = (e: Event) => {
            const target = e.target as HTMLInputElement;
            // name属性が phone_number の input 要素を対象にする
            if (target && target.name === 'phone_number') {
                let value = target.value;
                // 先頭に「0」があれば取り除く
                if (value.startsWith('0')) {
                    target.value = value.replace(/^0+/, '');
                    // Reactに値の変更を通知するためのイベントを発火
                    target.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        };

        // document全体で input イベントをキャッチ（イベント委譲）
        // console.log('addEventListener: input');
        document.addEventListener('input', handleInput);

        return () => {
            // console.log('removeEventListener: input');
            document.removeEventListener('input', handleInput);
        };
    }, []);

    if (route === 'authenticated' && user) {
        return <Navigate to="/app/home" replace />;
    }

    const beCognito = systemInfo?.cognito?.userPoolId;
    const feCognito = cognitoConstants.Auth.Cognito.userPoolId;
    if (systemInfo && beCognito && beCognito !== feCognito) {
        return (
            <div data-amplify-authenticator data-variation="default">
                <div data-amplify-container>
                    <div style={{ padding: 'var(--amplify-space-xxl' }}></div>
                    <div data-amplify-router>
                        <div data-amplify-router-content>
                            <div
                                style={{
                                    margin: 'var(--amplify-space-xl)',
                                }}
                            >
                                <h6
                                    className="amplify-heading amplify-heading--6"
                                    style={{
                                        fontSize:
                                            'var(--amplify-font-sizes-large)',
                                    }}
                                >
                                    Error: User Cognito Mismatch
                                </h6>
                                <ul>
                                    <li>Frontend: {feCognito}</li>
                                    <li>Backend: {beCognito}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <Authenticator {...authenticatorSettings} />;
};
